module.exports = "<p>\r\n  request-clip works!\r\n</p>\r\n"